import { createServerFn } from "@tanstack/react-start";
import { createClient } from "@supabase/supabase-js";
import type { Database } from "@/integrations/supabase/types";

function pub() {
  return createClient<Database>(
    process.env.SUPABASE_URL!,
    process.env.SUPABASE_PUBLISHABLE_KEY!,
    { auth: { storage: undefined, persistSession: false, autoRefreshToken: false } },
  );
}

export const listServices = createServerFn({ method: "GET" }).handler(async () => {
  const { data, error } = await pub()
    .from("services")
    .select("slug,label,description,icon,route_path,order_index,cover_image,meta_title,meta_description")
    .eq("active", true)
    .order("order_index");
  if (error) throw error;
  return data ?? [];
});

export const listLocations = createServerFn({ method: "GET" }).handler(async () => {
  const { data, error } = await pub()
    .from("service_locations")
    .select("location_slug,city,neighborhood")
    .eq("service_slug", "dedetizacao")
    .eq("published", true)
    .order("neighborhood", { ascending: true, nullsFirst: true })
    .order("city");
  if (error) throw error;
  const seen = new Set<string>();
  const out: { location_slug: string; city: string; neighborhood: string | null; display: string }[] = [];
  for (const r of data ?? []) {
    if (!r.location_slug || seen.has(r.location_slug)) continue;
    seen.add(r.location_slug);
    const display = r.neighborhood ? `${r.neighborhood} · Chapecó` : `${r.city} · SC`;
    out.push({ location_slug: r.location_slug, city: r.city, neighborhood: r.neighborhood, display });
  }
  return out;
});

export const getServiceLocationsBySlug = createServerFn({ method: "GET" })
  .inputValidator((d: { service_slug: string }) => d)
  .handler(async ({ data }) => {
    const { data: rows, error } = await pub()
      .from("service_locations")
      .select("slug,location_slug,city,neighborhood,title,description")
      .eq("service_slug", data.service_slug)
      .eq("published", true)
      .order("neighborhood", { ascending: true, nullsFirst: true })
      .order("city");
    if (error) throw error;
    return rows ?? [];
  });

export const getServiceLocationPage = createServerFn({ method: "GET" })
  .inputValidator((d: { location_slug: string; service_slug: string }) => d)
  .handler(async ({ data }) => {
    const { data: row, error } = await pub()
      .from("service_locations")
      .select("*")
      .eq("service_slug", data.service_slug)
      .eq("location_slug", data.location_slug)
      .eq("published", true)
      .maybeSingle();
    if (error) throw error;
    return row;
  });

export const getService = createServerFn({ method: "GET" })
  .inputValidator((d: { slug: string }) => d)
  .handler(async ({ data }) => {
    const { data: row, error } = await pub()
      .from("services")
      .select("*")
      .eq("slug", data.slug)
      .eq("active", true)
      .maybeSingle();
    if (error) throw error;
    return row;
  });
